import * as types from './types';
import produce from 'immer';

const initialState = {
  error: false,
  popwindow: false,
  loading: false,
  payload: null,
  meta: null
};

const reducer = (state = initialState, action) =>
  produce(state, draft => {
    const { type = '', payload, meta } = action;
    // console.log(type);

    //if (type.startsWith('SAVE_TRANSLATION')) {
    if (type.startsWith('SAVE')) {
      draft.popwindow = true;
    }

    else if (type.startsWith('TRANSLATION') || type.startsWith('APPROVE')  || type.startsWith('USERINFO')) {
      draft.popwindow = false;
    }

   // if (type.startsWith('SAVE_REJECTION') || type.startsWith('LOGOUT_REQUEST')) {
    else if (type.startsWith('LOGOUT_REQUEST')) {
      //alert('close');
      draft.popwindow = false;
    }

    else if (type.startsWith('SETFLAG_FALSE')) {
      draft.popwindow = false;
    }
    else if (type.endsWith('_REQUEST')) {
      draft.loading = true;
    }
    else if (type.endsWith('_ERROR')) {
      draft.loading = false;
      draft.error = true;

      draft.payload = payload;
      draft.meta = meta;
    }
    else if (type.endsWith('_SUCCESS')) {
      draft.loading = false;
      draft.error = false;

      draft.payload = payload;
      draft.meta = meta;
    }
    switch (action.type) {
      case types.RESET_STATUS:
        draft.popup = false;
        draft.loading = false;
        draft.error = false;
        draft.payload = null;
        draft.meta = null;

        break;

      default:
        break;
    }
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/state/status/reducer.js